import React from 'react'

import Link from '@Pure/Link'

import { mergeDeep } from '@root/utility'

import { form as default_form_config } from '@Config/Catalog/product'

var form =
{
	model: 'product',

	form_title: 'Billet',

	fields:
	{
		theme:
		{
			label: 'Thème',
			reference:
			{
				model: 'ShowTheme'.toLowerCase(),
				referenced_field:
				{
					name: 'label',
					type: 'text'
				},
				autocomplete: ['label']
			}
		},

		client_public:
		{
			label: 'Public',
			reference:
			{
				model: 'public',
				referenced_field:
				{
					name: 'label',
					type: 'text'
				},
				autocomplete:
				{
					'label':
					{
						type: 'text'
					}
				}
			}
		},

		places:
		{
			label: 'Lieu',
			reference:
			{
				model: 'Place'.toLowerCase(),
				referenced_field:
				{
					name: 'name',
					type: 'text'
				}
			},
			autocomplete: 'name'
		},

		national_brand:
		{
			label: 'Enseigne nationale',
			reference:
			{
				model: 'NationalBrand'.toLowerCase(),
				referenced_field: { name: 'name', type: 'text' },
				autocomplete: 'name'
			}
		},

		family:
		{
			label: 'Famille',
			reference:
			{
				model: 'ProductFamily'.toLowerCase(),
				referenced_field:
				{
					name: 'label',
					type: 'text'
				},
				autocomplete:
				{
					'label':
					{
						type: 'text'
					}
				}
			}
		},

		artist:
		{
			label: 'Artiste',
			reference:
			{
				model: 'artist',
				referenced_field:
				{
					name: 'name',
					type: 'text'
				},
				autocomplete:
				{
					'name':
					{
						type: 'text'
					}
				}
			},
			front_indicator: true
		},

		'disabled':
		{
			label: 'Désactiver le produit',
			type: 'checkbox',

			'col-size': '3'
		},

		'online_type':
		{
			label: 'Type de billet',
			defaultValue: 'none',
			type: 'select',
			options:
			[
				{
					value: 'none',
					label: 'Aucun'
				},
				{
					value: 'instant',
					label: 'E-billet instantané'
				},
				{
					value: '24_48',
					label: 'E-billet 24/48h'
				},
				{
					value: '48_72',
					label: 'Courrier 48h/72h'
				}
			],

			'col-size': '4'
		},

		'qrcode_template':
		{
			label: 'Gabarit du PDF',
			defaultValue: '',
			type: 'select',
			options:
			[
				{
					value: '',
					label: ''
				},
				{
					value: 'atlanthal',
					label: 'Atlanthal'
				},
				{
					value: 'cinema',
					label: 'Cinéma - avec code web'
				},
				{
					value: 'cinema_noweb',
					label: 'Cinéma - sans code web'
				},
				{
					value: 'bateau_mouche',
					label: 'Bateau mouche - code barre plus petit'
				},
				{
					value: 'web_code_only',
					label: 'Code web uniquement'
				},
				{
					value: 'default',
					label: 'QR-Code & Web'
				},
				{
					value: 'qrcode_only',
					label: 'QR-Code uniquement'
				},
				{
					value: 'parks',
					label: 'Parc aquatiques'
				},
				{
					value: 'no_partner_logo',
					label: 'Chambord (pas de logo du partenaire)'
				}
			],

			'col-size': '4'
		},

		'legal_mentions':
		{
			label: 'Mention courte (sous le label)',
			type: 'text',

			'col-size': '12',

			show: function (data)
			{
				const hidden =
				[
					'atlanthal'
				]
				.includes(data['product[qrcode_template]']);

				return !hidden;
			}
		},

		'qrcode_text':
		{
			label: 'Texte 1',
			type: 'textarea',

			show: function (data)
			{
				const hidden =
				[
					'atlanthal'
				]
				.includes(data['product[qrcode_template]']);

				return !hidden;
			}
		},

		'qrcode_type':
		{
			label: 'Format du code',

			defaultValue: 'qr_code',
			type: 'select',
			options:
			[
				{
					value: 'qr_code',
					label: 'QR-Code'
				},
				{
					value: 'bar_code',
					label: 'Code-barres'
				}
			],

			'col-size': '4',

			show: function (data)
			{
				const hidden =
				[
					'atlanthal',
					'web_code_only',
					'qrcode_only'
				]
				.includes(data['product[qrcode_template]']);

				return !hidden;
			}
		},

		'qrcode_text_2':
		{
			label: 'Texte 2',
			type: 'textarea',

			show: function (data)
			{
				return ['cinema', 'cinema_noweb', 'bateau_mouche']
				.includes(data['product[qrcode_template]']);
			}
		},

		'prices[ref]':
		{
			label: 'Ref',
			readOnly: true
		},

		'prices[status]':
		{
			type: 'select',
			defaultValue: 'available',
			options:
			[
				{
					label: 'Disponible',
					value: 'available'
				},
				{
					label: 'Complet',
					value: 'full'
				},
				{
					label: 'Annulé',
					value: 'canceled'
				}
			]
		},

		'prices[disabled]':
		{
			type: 'checkbox'
		},

		'prices[archived]':
		{
			type: 'checkbox'
		},

		'prices[online_ticket]':
		{
			type: 'checkbox'
		},

		'prices[nominative]':
		{
			type: 'checkbox'
		},

		'prices[provider]':
		{
			reference:
			{
				model: 'provider',
				referenced_field:
				{
					name: 'name',
					type: 'text'
				},
				autocomplete:
				{
					'name':
					{
						type: 'text'
					}
				}
			}
		},

		'prices[position]':
		{
			reference:
			{
				model: 'ShowPosition'.toLowerCase(),
				referenced_field:
				{
					name: 'label',
					type: 'text'
				},
				autocomplete:
				{
					'label':
					{
						type: 'text'
					}
				}
			}
		},

		'prices[type]':
		{
			type: 'select',
			options:
			[
				{
					value: 'Prix Public'
				},
				{
					value: 'Prix CE'
				},
				{
					value: 'Prix Synergies'
				},
				{
					value: 'Prix Spécial'
				}
			]
		},

		'prices[ticket_type]':
		{
			reference:
			{
				model: 'TicketType'.toLowerCase(),
				referenced_field:
				{
					name: 'label',
					type: 'text'
				},
				autocomplete:
				{
					'label':
					{
						type: 'text'
					}
				}
			}
		},

		'prices[price]':
		{
			type: 'text'
		},

		'prices[qty]':
		{
			type: 'number',
			html_attributes:
			{
				min: 0
			}
		},

		'prices[date]':
		{
			type: 'datetime-local'
		},

		'prices[limit_date]':
		{
			type: 'date'
		},

		'prices[validity_start]':
		{
			type: 'date'
		},

		'prices[validity_date]':
		{
			type: 'date'
		},

		'prices[age]':
		{
			reference:
			{
				model: 'age',
				referenced_field:
				{
					name: 'label',
					type: 'text'
				},
				autocomplete:
				{
					'label':
					{
						type: 'text'
					}
				}
			}
		},

		'prices[comment]':
		{
			type: 'text'
		},

		'prices[discount_threshold]':
		{
			type: 'text'
		},

		'prices[public_price]':
		{
			type: 'text'
		},

		'pricing_type':
		{
			label: 'Type de tarification',
			type: 'select',
			options:
			[
				{
					label: 'Billet Simple',
					value: 'simple_product'
				},
				{
					label: 'Spectacle',
					value: 'show_product'
				},
				{
					label: 'Parc d\'attraction',
					value: 'parc_product'
				}
			]
		},

		'date_required':
		{
			label: 'Le client doit renseigner une date',
			type: 'checkbox',

			'col-size': '3'
		},

		'display_archived':
		{
			label: 'Afficher les archivés',
			type: 'checkbox',

			'col-size': '3'
		},

		'highlighted':
		{
			label: 'À ne pas rater (accueil)',
			type: 'checkbox',

			'col-size': '3'
		},

		place_themes:
		{
			label: 'Thèmes principaux',
			reference:
			{
				model: 'PlaceTheme'.toLowerCase(),
				referenced_field:
				{
					name: 'label',
					type: 'text'
				}
			},
			autocomplete: 'label'
		},

		custom_quotes:
		{
			label: 'Demandes de devis',
			reference:
			{
				model: 'CustomQuote'.toLowerCase(),
				referenced_field:
				{
					name: 'title',
					type: 'text'
				}
			},
			autocomplete: 'title'
		},

		'pdfs':
		{
			type: 'pdf',
			multiple: true,
			label: 'PDFs à joindre'
		}
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouveau billet <strong> { model.name } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/gestion-du-catalogue/billets/' + model.id }>
						Voir le billet
					</Link>
				</div>
			</div>
		);

		return output;
	},

	'create_label': 'Créer ce billet',

	collapses:
	[
		{
			title: 'Général',
			open: true,
			elements:
			[
				'name',
				'send_notifications',
				'client_public',
				'description',
				'family',
				'artist',
				'highlighted',
				'is_individuel',
				'disabled',
				'pdfs',
			]
		},
		{
			title: 'QR-CODE',
			open: true,
			elements:
			[
				'online_type',
				'qrcode_template',
				'qrcode_type',
				'legal_mentions',
				'qrcode_text',
				'qrcode_text_2'
			]
		},
		{
			title:'Tarification',
			open: true,

			elements:
			[
				'pricing_type',
				'date_required',
				'display_archived',
				{
					type: 'table',
					table_name: 'prices',
					hide_name: 'archived',
					show_hidden: 'display_archived',
					break: true,
					columns:
					{
						'Ref'              : 'prices[ref]',
						'Fournisseur'      : 'prices[provider]',
						'Type de prix'     : 'prices[type]',
						'Type de billet'   : 'prices[ticket_type]',
						'Prix'             : 'prices[price]',
						'Nominatif'        : 'prices[nominative]',
						'Electronique'     : 'prices[online_ticket]',
						'Commentaire'      : 'prices[comment]',
						'Début de validité': 'prices[validity_start]',
						'Fin de validité'  : 'prices[validity_date]',
						'Qté'              : 'prices[qty]',
						'Date limite'      : 'prices[limit_date]',
						'Désactivé'        : 'prices[disabled]',
						'Archivé'          : 'prices[archived]',
						'Seuil alerte'     : 'prices[discount_threshold]',
						'Prix public'      : 'prices[public_price]'
					},
					add: true,
					add_label: 'Ajouter',
					copy: true,
					copy_label: 'Copier le prix précédent',
					show: data => data['product[pricing_type]'] === 'simple_product'
				},
				{
					type: 'table',
					table_name: 'prices',
					hide_name: 'archived',
					show_hidden: 'display_archived',
					break: true,
					columns:
					{
						'Ref'              : 'prices[ref]',
						'Date'             : 'prices[date]',
						'Fournisseur'      : 'prices[provider]',
						'Age'              : 'prices[age]',
						'Type de prix'     : 'prices[type]',
						'Type de billet'   : 'prices[ticket_type]',
						'Prix'             : 'prices[price]',
						'Nominatif'        : 'prices[nominative]',
						'Electronique'     : 'prices[online_ticket]',
						'Commentaire'      : 'prices[comment]',
						'Début de validité': 'prices[validity_start]',
						'Fin de validité'  : 'prices[validity_date]',
						'Qté'              : 'prices[qty]',
						'Date limite'      : 'prices[limit_date]',
						'Désactivé'        : 'prices[disabled]',
						'Archivé'          : 'prices[archived]',
						'Seuil alerte'     : 'prices[discount_threshold]'
					},
					add: true,
					add_label: 'Ajouter',
					copy: true,
					copy_label: 'Copier le prix précédent',
					show: data => data['product[pricing_type]'] === 'parc_product'
				},
				{
					type: 'table',
					table_name: 'prices',
					hide_name: 'archived',
					show_hidden: 'display_archived',
					break: true,
					columns:
					{
						'Ref'         : 'prices[ref]',
						'Date'        : 'prices[date]',
						'Fournisseur' : 'prices[provider]',
						'Placement'   : 'prices[position]',
						'Age'         : 'prices[age]',
						'Type de prix': 'prices[type]',
						'Prix'        : 'prices[price]',
						'Nominatif'   : 'prices[nominative]',
						'Electronique': 'prices[online_ticket]',
						'Status'      : 'prices[status]',
						'Commentaire' : 'prices[comment]',
						'Qté'         : 'prices[qty]',
						'Date limite' : 'prices[limit_date]',
						'Désactivé'   : 'prices[disabled]',
						'Archivé'     : 'prices[archived]',
						'Seuil alerte': 'prices[discount_threshold]'
					},
					add: true,
					add_label: 'Ajouter',
					copy: true,
					copy_label: 'Copier le prix précédent',

					show: function (data)
					{
						return data['product[pricing_type]'] === 'show_product';
					}
				}
			]
		},
		{
			title: 'Media',
			open: true,
			elements:
			[
				'images',
				'videos',
				'national_brand'
			]
		}
	],

	repeatable:
	[
		'prices'
	],

	views:
	[
		{
			title: 'Lieux',
			search_label: 'Chercher un lieu',
			source_field: 'places',
			add_label: 'Ajouter ce lieu',
			grid_class: 'o-grid-4',
			render: function (data, key)
			{
				let output =
				(
					<div className="o-grid__item" key={ key }>

						<div className="c-view-item">
							<div className="c-view-item__infos">
								<div className="c-view-item__data">
									{ data.model_data.name }
								</div>
							</div>
						</div>

					</div>
				);

				return output;
			},
			search:
			{
				display_fields: ['name']
			}
		},
		{
			title: 'Thèmes de spectacle',
			search_label: 'Chercher un thème',
			source_field: 'theme',
			add_label: 'Ajouter ce thème',
			grid_class: 'o-grid-4',
			render: function (data, key)
			{
				let output =
				(
					<div className="o-grid__item" key={ key }>

						<div className="c-view-item">
							<div className="c-view-item__infos">
								<div className="c-view-item__data">
									{ data.model_data.label }
								</div>
							</div>
						</div>

					</div>
				);

				return output;
			},
			search:
			{
				display_fields: ['label']
			}
		},
		{
			title: 'Thèmes principaux',
			search_label: 'Chercher un thème principal',
			source_field: 'place_themes',
			add_label: 'Ajouter ce thème',
			grid_class: 'o-grid-4',
			render: function (data, key)
			{
				let output =
				(
					<div className="o-grid__item" key={ key }>

						<div className="c-view-item">
							<div className="c-view-item__infos">
								<div className="c-view-item__data">
									{ data.model_data.label }
								</div>
							</div>
						</div>

					</div>
				);

				return output;
			},
			search:
			{
				display_fields: ['label']
			}
		},
		{
			title: 'Demandes de devis',
			search_label: 'Chercher une demande de devis',
			source_field: 'custom_quotes',
			add_label: 'Ajouter cette demande de devis',
			grid_class: 'o-grid-4',
			render: function (data, key)
			{

				let output =
				(
					<div className="o-grid__item" key={ key }>

						<div className="c-view-item">
							<div className="c-view-item__infos">
								<div className="c-view-item__data">
									{ data.model_data.title }
									{ ' (' + data.model_data.elements.length + ' champs )' }
								</div>
							</div>
						</div>

					</div>
				);

				return output;
			},
			search:
			{
				display_fields: ['label']
			}
		}
	]
};

let list =
{
	link          : '/gestion-du-catalogue/billets',
	creation_link : '/gestion-du-catalogue/nouveau-billet',
	creation_label: 'Nouveau billet',
	row_link_base : '/gestion-du-catalogue/billets/',
	title         : 'billetterie',

	header_map:
	{
		'Nom'    : 'name',
		'Type'   : 'pricing_type',
		'Artiste': 'artist',
		'Lieu'   : 'places.name'
	},

	field_hook:
	{
		'Type': function (value)
		{
			if (value === 'show_product')
			{
				return 'Spectacle';
			}
			else if (value === 'parc_product')
			{
				return 'Parc d\'attraction'
			}
			else
			{
				return 'Billet simple';
			}
		}
	},

	searched_prop: ['name', 'places.address.city']
};

form = mergeDeep(default_form_config, form);

var config = mergeDeep(form, list);

export { form, list }

export default config